module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.error) ? [_c('div', {
    staticClass: "alert alert-danger alert-dismissable"
  }, [_c('p', [_vm._v(_vm._s(_vm.error))])])] : _vm._e(), _vm._v(" "), (!_vm.error) ? [(_vm.message) ? _c('div', {
    staticClass: "alert alert-info alert-dismissable"
  }, [_c('p', [_vm._v(_vm._s(_vm.message))])]) : _vm._e(), _vm._v(" "), (Object.keys(_vm.errors).length) ? _c('div', {
    staticClass: "alert alert-danger alert-dismissable"
  }, [_vm._l((_vm.errors), function(error) {
    return _vm._l((error), function(v) {
      return _c('p', [_vm._v(_vm._s(v))])
    })
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row col-sm-12"
  }, [(!_vm.review.deleted_at) ? _c('div', {
    staticClass: "pull-right"
  }) : _vm._e()]), _vm._v(" "), (_vm.id) ? _c('text-group', {
    attrs: {
      "label": '口コミ番号',
      "val": _vm.review.review_id,
      "readonly": true
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.id) ? _c('text-group', {
    attrs: {
      "label": '口コミ番号',
      "val": "新規発番",
      "readonly": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.review.member_id) ? _c('text-group', {
    attrs: {
      "label": '会員',
      "val": _vm.review.member_id,
      "readonly": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.review.created_at) ? _c('text-group', {
    attrs: {
      "label": '登録日時',
      "readonly": true,
      "val": _vm.review.created_at
    }
  }) : _vm._e(), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": '公開/非公開',
      "require": true
    }
  }, [_c('template', {
    slot: "text"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.review.is_public),
      expression: "review.is_public"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.review, "is_public", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_vm._l(({
    0: {
      tag_value: '0',
      tag_name: '非公開'
    },
    1: {
      tag_value: '1',
      tag_name: '公開'
    }
  }), function(tag) {
    return [_c('option', {
      domProps: {
        "value": tag.tag_value
      }
    }, [_vm._v(_vm._s(tag.tag_name))])]
  })], 2)])], 2), _vm._v(" "), (_vm.review.company) ? [_c('text-group', {
    attrs: {
      "label": '連携企業',
      "val": _vm.review.company.name,
      "readonly": true
    }
  })] : _vm._e(), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": '企業名',
      "val": _vm.review.company_name,
      "require": true
    },
    model: {
      value: (_vm.review.company_name),
      callback: function($$v) {
        _vm.$set(_vm.review, "company_name", $$v)
      },
      expression: "review.company_name"
    }
  }), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": ''
    }
  }, [_c('template', {
    slot: "text"
  }, [_c('router-link', {
    attrs: {
      "to": ("/company/review/check?review_id=" + (_vm.review.review_id))
    }
  }, [_vm._v("※ 連携会社を更新する")])], 1)], 2), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": 'ホームページURL',
      "val": _vm.review.company_url,
      "require": true
    },
    model: {
      value: (_vm.review.company_url),
      callback: function($$v) {
        _vm.$set(_vm.review, "company_url", $$v)
      },
      expression: "review.company_url"
    }
  }), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": '常駐/自社',
      "require": true
    }
  }, [_c('template', {
    slot: "text"
  }, [_vm._l((this.$store.state.tags.working_space_id), function(tag) {
    return [_c('label', {
      staticClass: "radioMargin"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.review.working_space_id),
        expression: "review.working_space_id"
      }],
      attrs: {
        "type": "radio",
        "name": "working_space_id"
      },
      domProps: {
        "value": tag.tag_value,
        "checked": _vm._q(_vm.review.working_space_id, tag.tag_value)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.review, "working_space_id", tag.tag_value)
        }
      }
    }), _vm._v("\n            " + _vm._s(tag.tag_name) + "\n          ")])]
  })], 2)], 2), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": '当時のステータス',
      "require": true
    }
  }, [_c('template', {
    slot: "text"
  }, [_vm._l((this.$store.state.tags.employment_id), function(tag) {
    return [_c('label', {
      staticClass: "radioMargin"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.review.employment_id),
        expression: "review.employment_id"
      }],
      attrs: {
        "type": "radio",
        "name": "employment_id"
      },
      domProps: {
        "value": tag.tag_value,
        "checked": _vm._q(_vm.review.employment_id, tag.tag_value)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.review, "employment_id", tag.tag_value)
        }
      }
    }), _vm._v("\n            " + _vm._s(tag.tag_name) + "\n          ")])]
  })], 2)], 2), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": '参画時の精算幅',
      "val": _vm.review.project_contract_time,
      "require": true
    },
    model: {
      value: (_vm.review.project_contract_time),
      callback: function($$v) {
        _vm.$set(_vm.review, "project_contract_time", $$v)
      },
      expression: "review.project_contract_time"
    }
  }), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": '最寄駅',
      "val": _vm.review.company_station,
      "require": true
    },
    model: {
      value: (_vm.review.company_station),
      callback: function($$v) {
        _vm.$set(_vm.review, "company_station", $$v)
      },
      expression: "review.company_station"
    }
  }), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": '案件名',
      "val": _vm.review.project_title,
      "require": true
    },
    model: {
      value: (_vm.review.project_title),
      callback: function($$v) {
        _vm.$set(_vm.review, "project_title", $$v)
      },
      expression: "review.project_title"
    }
  }), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": '就業時間',
      "val": _vm.review.project_working_time,
      "require": true
    },
    model: {
      value: (_vm.review.project_working_time),
      callback: function($$v) {
        _vm.$set(_vm.review, "project_working_time", $$v)
      },
      expression: "review.project_working_time"
    }
  }), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": '上記案件に関わった人数',
      "val": _vm.review.project_member_num,
      "require": true
    },
    model: {
      value: (_vm.review.project_member_num),
      callback: function($$v) {
        _vm.$set(_vm.review, "project_member_num", $$v)
      },
      expression: "review.project_member_num"
    }
  }), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": '上記案件に関わった時期',
      "val": _vm.review.project_attach_season,
      "require": true
    },
    model: {
      value: (_vm.review.project_attach_season),
      callback: function($$v) {
        _vm.$set(_vm.review, "project_attach_season", $$v)
      },
      expression: "review.project_attach_season"
    }
  }), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": '職種',
      "require": true
    }
  }, [_c('template', {
    slot: "text"
  }, [_vm._l((this.$store.state.tags.occupation_id), function(tag) {
    return [_c('label', {
      staticClass: "radioMargin"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.review.occupation_id),
        expression: "review.occupation_id"
      }],
      attrs: {
        "type": "checkbox",
        "name": "occupation_id"
      },
      domProps: {
        "value": tag.tag_value,
        "checked": Array.isArray(_vm.review.occupation_id) ? _vm._i(_vm.review.occupation_id, tag.tag_value) > -1 : (_vm.review.occupation_id)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.review.occupation_id,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tag.tag_value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.review, "occupation_id", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.review, "occupation_id", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.review, "occupation_id", $$c)
          }
        }
      }
    }), _vm._v("\n            " + _vm._s(tag.tag_name) + "\n          ")])]
  })], 2)], 2), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": '言語'
    }
  }, [_c('template', {
    slot: "text"
  }, [_vm._l((this.$store.state.tags.language_id), function(tag) {
    return [_c('label', {
      staticClass: "radioMargin"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.review.language_id),
        expression: "review.language_id"
      }],
      attrs: {
        "type": "checkbox",
        "name": "language_id"
      },
      domProps: {
        "value": tag.tag_value,
        "checked": Array.isArray(_vm.review.language_id) ? _vm._i(_vm.review.language_id, tag.tag_value) > -1 : (_vm.review.language_id)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.review.language_id,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tag.tag_value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.review, "language_id", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.review, "language_id", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.review, "language_id", $$c)
          }
        }
      }
    }), _vm._v("\n            " + _vm._s(tag.tag_name) + "\n          ")])]
  })], 2)], 2), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": 'フレームワーク'
    }
  }, [_c('template', {
    slot: "text"
  }, [_vm._l((this.$store.state.tags.framework_id), function(tag) {
    return [_c('label', {
      staticClass: "radioMargin"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.review.framework_id),
        expression: "review.framework_id"
      }],
      attrs: {
        "type": "checkbox",
        "name": "framework_id"
      },
      domProps: {
        "value": tag.tag_value,
        "checked": Array.isArray(_vm.review.framework_id) ? _vm._i(_vm.review.framework_id, tag.tag_value) > -1 : (_vm.review.framework_id)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.review.framework_id,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tag.tag_value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.review, "framework_id", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.review, "framework_id", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.review, "framework_id", $$c)
          }
        }
      }
    }), _vm._v("\n            " + _vm._s(tag.tag_name) + "\n          ")])]
  })], 2)], 2), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": 'アプリ/ツール/CMS類 （開発系）'
    }
  }, [_c('template', {
    slot: "text"
  }, [_vm._l((this.$store.state.tags.develop_tool_id), function(tag) {
    return [_c('label', {
      staticClass: "radioMargin"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.review.develop_tool_id),
        expression: "review.develop_tool_id"
      }],
      attrs: {
        "type": "checkbox",
        "name": "develop_tool_id"
      },
      domProps: {
        "value": tag.tag_value,
        "checked": Array.isArray(_vm.review.develop_tool_id) ? _vm._i(_vm.review.develop_tool_id, tag.tag_value) > -1 : (_vm.review.develop_tool_id)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.review.develop_tool_id,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tag.tag_value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.review, "develop_tool_id", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.review, "develop_tool_id", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.review, "develop_tool_id", $$c)
          }
        }
      }
    }), _vm._v("\n            " + _vm._s(tag.tag_name) + "\n          ")])]
  })], 2)], 2), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": 'アプリ/ツール類 （テスト/他）'
    }
  }, [_c('template', {
    slot: "text"
  }, [_vm._l((this.$store.state.tags.test_tool_id), function(tag) {
    return [_c('label', {
      staticClass: "radioMargin"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.review.test_tool_id),
        expression: "review.test_tool_id"
      }],
      attrs: {
        "type": "checkbox",
        "name": "test_tool_id"
      },
      domProps: {
        "value": tag.tag_value,
        "checked": Array.isArray(_vm.review.test_tool_id) ? _vm._i(_vm.review.test_tool_id, tag.tag_value) > -1 : (_vm.review.test_tool_id)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.review.test_tool_id,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tag.tag_value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.review, "test_tool_id", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.review, "test_tool_id", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.review, "test_tool_id", $$c)
          }
        }
      }
    }), _vm._v("\n            " + _vm._s(tag.tag_name) + "\n          ")])]
  })], 2)], 2), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": 'アプリ/ツール類 （デザイン/他）'
    }
  }, [_c('template', {
    slot: "text"
  }, [_vm._l((this.$store.state.tags.design_tool_id), function(tag) {
    return [_c('label', {
      staticClass: "radioMargin"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.review.design_tool_id),
        expression: "review.design_tool_id"
      }],
      attrs: {
        "type": "checkbox",
        "name": "design_tool_id"
      },
      domProps: {
        "value": tag.tag_value,
        "checked": Array.isArray(_vm.review.design_tool_id) ? _vm._i(_vm.review.design_tool_id, tag.tag_value) > -1 : (_vm.review.design_tool_id)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.review.design_tool_id,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tag.tag_value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.review, "design_tool_id", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.review, "design_tool_id", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.review, "design_tool_id", $$c)
          }
        }
      }
    }), _vm._v("\n            " + _vm._s(tag.tag_name) + "\n          ")])]
  })], 2)], 2), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": 'アプリ/ツール類 （管理系、その他一般）'
    }
  }, [_c('template', {
    slot: "text"
  }, [_vm._l((this.$store.state.tags.manager_tool_id), function(tag) {
    return [_c('label', {
      staticClass: "radioMargin"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.review.manager_tool_id),
        expression: "review.manager_tool_id"
      }],
      attrs: {
        "type": "checkbox",
        "name": "manager_tool_id"
      },
      domProps: {
        "value": tag.tag_value,
        "checked": Array.isArray(_vm.review.manager_tool_id) ? _vm._i(_vm.review.manager_tool_id, tag.tag_value) > -1 : (_vm.review.manager_tool_id)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.review.manager_tool_id,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tag.tag_value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.review, "manager_tool_id", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.review, "manager_tool_id", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.review, "manager_tool_id", $$c)
          }
        }
      }
    }), _vm._v("\n            " + _vm._s(tag.tag_name) + "\n          ")])]
  })], 2)], 2), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": 'アプリ/ツール類 （ERP、RPA他系）'
    }
  }, [_c('template', {
    slot: "text"
  }, [_vm._l((this.$store.state.tags.erp_tool_id), function(tag) {
    return [_c('label', {
      staticClass: "radioMargin"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.review.erp_tool_id),
        expression: "review.erp_tool_id"
      }],
      attrs: {
        "type": "checkbox",
        "name": "erp_tool_id"
      },
      domProps: {
        "value": tag.tag_value,
        "checked": Array.isArray(_vm.review.erp_tool_id) ? _vm._i(_vm.review.erp_tool_id, tag.tag_value) > -1 : (_vm.review.erp_tool_id)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.review.erp_tool_id,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tag.tag_value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.review, "erp_tool_id", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.review, "erp_tool_id", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.review, "erp_tool_id", $$c)
          }
        }
      }
    }), _vm._v("\n            " + _vm._s(tag.tag_name) + "\n          ")])]
  })], 2)], 2), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": 'アプリ/ツール類 （BI/データ分析系）'
    }
  }, [_c('template', {
    slot: "text"
  }, [_vm._l((this.$store.state.tags.bi_tool_id), function(tag) {
    return [_c('label', {
      staticClass: "radioMargin"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.review.bi_tool_id),
        expression: "review.bi_tool_id"
      }],
      attrs: {
        "type": "checkbox",
        "name": "bi_tool_id"
      },
      domProps: {
        "value": tag.tag_value,
        "checked": Array.isArray(_vm.review.bi_tool_id) ? _vm._i(_vm.review.bi_tool_id, tag.tag_value) > -1 : (_vm.review.bi_tool_id)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.review.bi_tool_id,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tag.tag_value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.review, "bi_tool_id", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.review, "bi_tool_id", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.review, "bi_tool_id", $$c)
          }
        }
      }
    }), _vm._v("\n            " + _vm._s(tag.tag_name) + "\n          ")])]
  })], 2)], 2), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": 'サーバー/OS'
    }
  }, [_c('template', {
    slot: "text"
  }, [_vm._l((this.$store.state.tags.os_id), function(tag) {
    return [_c('label', {
      staticClass: "radioMargin"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.review.os_id),
        expression: "review.os_id"
      }],
      attrs: {
        "type": "checkbox",
        "name": "os_id"
      },
      domProps: {
        "value": tag.tag_value,
        "checked": Array.isArray(_vm.review.os_id) ? _vm._i(_vm.review.os_id, tag.tag_value) > -1 : (_vm.review.os_id)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.review.os_id,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tag.tag_value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.review, "os_id", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.review, "os_id", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.review, "os_id", $$c)
          }
        }
      }
    }), _vm._v("\n            " + _vm._s(tag.tag_name) + "\n          ")])]
  })], 2)], 2), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": 'クラウド'
    }
  }, [_c('template', {
    slot: "text"
  }, [_vm._l((this.$store.state.tags.cloud_id), function(tag) {
    return [_c('label', {
      staticClass: "radioMargin"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.review.cloud_id),
        expression: "review.cloud_id"
      }],
      attrs: {
        "type": "checkbox",
        "name": "cloud_id"
      },
      domProps: {
        "value": tag.tag_value,
        "checked": Array.isArray(_vm.review.cloud_id) ? _vm._i(_vm.review.cloud_id, tag.tag_value) > -1 : (_vm.review.cloud_id)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.review.cloud_id,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tag.tag_value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.review, "cloud_id", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.review, "cloud_id", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.review, "cloud_id", $$c)
          }
        }
      }
    }), _vm._v("\n            " + _vm._s(tag.tag_name) + "\n          ")])]
  })], 2)], 2), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": '仮想環境'
    }
  }, [_c('template', {
    slot: "text"
  }, [_vm._l((this.$store.state.tags.virtual_id), function(tag) {
    return [_c('label', {
      staticClass: "radioMargin"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.review.virtual_id),
        expression: "review.virtual_id"
      }],
      attrs: {
        "type": "checkbox",
        "name": "virtual_id"
      },
      domProps: {
        "value": tag.tag_value,
        "checked": Array.isArray(_vm.review.virtual_id) ? _vm._i(_vm.review.virtual_id, tag.tag_value) > -1 : (_vm.review.virtual_id)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.review.virtual_id,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tag.tag_value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.review, "virtual_id", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.review, "virtual_id", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.review, "virtual_id", $$c)
          }
        }
      }
    }), _vm._v("\n            " + _vm._s(tag.tag_name) + "\n          ")])]
  })], 2)], 2), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": 'ミドルウェア/他'
    }
  }, [_c('template', {
    slot: "text"
  }, [_vm._l((this.$store.state.tags.middleware_id), function(tag) {
    return [_c('label', {
      staticClass: "radioMargin"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.review.middleware_id),
        expression: "review.middleware_id"
      }],
      attrs: {
        "type": "checkbox",
        "name": "middleware_id"
      },
      domProps: {
        "value": tag.tag_value,
        "checked": Array.isArray(_vm.review.middleware_id) ? _vm._i(_vm.review.middleware_id, tag.tag_value) > -1 : (_vm.review.middleware_id)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.review.middleware_id,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tag.tag_value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.review, "middleware_id", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.review, "middleware_id", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.review, "middleware_id", $$c)
          }
        }
      }
    }), _vm._v("\n            " + _vm._s(tag.tag_name) + "\n          ")])]
  })], 2)], 2), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": 'DB'
    }
  }, [_c('template', {
    slot: "text"
  }, [_vm._l((this.$store.state.tags.database_id), function(tag) {
    return [_c('label', {
      staticClass: "radioMargin"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.review.database_id),
        expression: "review.database_id"
      }],
      attrs: {
        "type": "checkbox",
        "name": "database_id"
      },
      domProps: {
        "value": tag.tag_value,
        "checked": Array.isArray(_vm.review.database_id) ? _vm._i(_vm.review.database_id, tag.tag_value) > -1 : (_vm.review.database_id)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.review.database_id,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tag.tag_value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.review, "database_id", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.review, "database_id", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.review, "database_id", $$c)
          }
        }
      }
    }), _vm._v("\n            " + _vm._s(tag.tag_name) + "\n          ")])]
  })], 2)], 2), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": 'Network'
    }
  }, [_c('template', {
    slot: "text"
  }, [_vm._l((this.$store.state.tags.network_id), function(tag) {
    return [_c('label', {
      staticClass: "radioMargin"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.review.network_id),
        expression: "review.network_id"
      }],
      attrs: {
        "type": "checkbox",
        "name": "network_id"
      },
      domProps: {
        "value": tag.tag_value,
        "checked": Array.isArray(_vm.review.network_id) ? _vm._i(_vm.review.network_id, tag.tag_value) > -1 : (_vm.review.network_id)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.review.network_id,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tag.tag_value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.review, "network_id", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.review, "network_id", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.review, "network_id", $$c)
          }
        }
      }
    }), _vm._v("\n            " + _vm._s(tag.tag_name) + "\n          ")])]
  })], 2)], 2), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": 'その他/キーワード'
    }
  }, [_c('template', {
    slot: "text"
  }, [_vm._l((this.$store.state.tags.other_skill_id), function(tag) {
    return [_c('label', {
      staticClass: "radioMargin"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.review.other_skill_id),
        expression: "review.other_skill_id"
      }],
      attrs: {
        "type": "checkbox",
        "name": "other_skill_id"
      },
      domProps: {
        "value": tag.tag_value,
        "checked": Array.isArray(_vm.review.other_skill_id) ? _vm._i(_vm.review.other_skill_id, tag.tag_value) > -1 : (_vm.review.other_skill_id)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.review.other_skill_id,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tag.tag_value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.review, "other_skill_id", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.review, "other_skill_id", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.review, "other_skill_id", $$c)
          }
        }
      }
    }), _vm._v("\n            " + _vm._s(tag.tag_name) + "\n          ")])]
  })], 2)], 2), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('hr', {
    staticClass: "hr-line-dashed"
  }), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": '収入の満足度',
      "require": true
    }
  }, [_c('template', {
    slot: "text"
  }, [_c('review-evaluation-type1', {
    staticClass: "mod_listbox",
    attrs: {
      "rank": _vm.review.rank_good_salary,
      "title": false
    },
    on: {
      "update:rank": function($event) {
        return _vm.$set(_vm.review, "rank_good_salary", $event)
      }
    }
  }, [_c('template', {
    slot: "rank1"
  }, [_vm._v("低い")]), _vm._v(" "), _c('template', {
    slot: "rank2"
  }, [_vm._v("やや低い")]), _vm._v(" "), _c('template', {
    slot: "rank3"
  }, [_vm._v("普通")]), _vm._v(" "), _c('template', {
    slot: "rank4"
  }, [_vm._v("やや高い")]), _vm._v(" "), _c('template', {
    slot: "rank5"
  }, [_vm._v("高い")])], 2)], 1)], 2), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": '残業の多さ',
      "require": true
    }
  }, [_c('template', {
    slot: "text"
  }, [_c('review-evaluation-type1', {
    staticClass: "mod_listbox",
    attrs: {
      "rank": _vm.review.rank_overwork,
      "title": false
    },
    on: {
      "update:rank": function($event) {
        return _vm.$set(_vm.review, "rank_overwork", $event)
      }
    }
  }, [_c('template', {
    slot: "rank1"
  }, [_vm._v("多い")]), _vm._v(" "), _c('template', {
    slot: "rank2"
  }, [_vm._v("やや多い")]), _vm._v(" "), _c('template', {
    slot: "rank3"
  }, [_vm._v("普通")]), _vm._v(" "), _c('template', {
    slot: "rank4"
  }, [_vm._v("少なめ")]), _vm._v(" "), _c('template', {
    slot: "rank5"
  }, [_vm._v("ほぼ無し")])], 2)], 1)], 2), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": '雰囲気（仕事のやりやすさ）',
      "require": true
    }
  }, [_c('template', {
    slot: "text"
  }, [_c('review-evaluation-type1', {
    staticClass: "mod_listbox",
    attrs: {
      "rank": _vm.review.rank_good_team_mood,
      "title": false
    },
    on: {
      "update:rank": function($event) {
        return _vm.$set(_vm.review, "rank_good_team_mood", $event)
      }
    }
  }, [_c('template', {
    slot: "rank1"
  }, [_vm._v("やりにくい")]), _vm._v(" "), _c('template', {
    slot: "rank2"
  }, [_vm._v("少しやりにくい")]), _vm._v(" "), _c('template', {
    slot: "rank3"
  }, [_vm._v("普通")]), _vm._v(" "), _c('template', {
    slot: "rank4"
  }, [_vm._v("少しやりやすい")]), _vm._v(" "), _c('template', {
    slot: "rank5"
  }, [_vm._v("やりやすい")])], 2)], 1)], 2), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": '仕事のやりがい・達成感',
      "require": true
    }
  }, [_c('template', {
    slot: "text"
  }, [_c('review-evaluation-type1', {
    staticClass: "mod_listbox",
    attrs: {
      "rank": _vm.review.rank_good_reward,
      "title": false
    },
    on: {
      "update:rank": function($event) {
        return _vm.$set(_vm.review, "rank_good_reward", $event)
      }
    }
  }, [_c('template', {
    slot: "rank1"
  }, [_vm._v("感じなかった")]), _vm._v(" "), _c('template', {
    slot: "rank2"
  }, [_vm._v("やや感じなかった")]), _vm._v(" "), _c('template', {
    slot: "rank3"
  }, [_vm._v("普通")]), _vm._v(" "), _c('template', {
    slot: "rank4"
  }, [_vm._v("やや感じた")]), _vm._v(" "), _c('template', {
    slot: "rank5"
  }, [_vm._v("感じた")])], 2)], 1)], 2), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": 'PC環境',
      "require": true
    }
  }, [_c('template', {
    slot: "text"
  }, [_c('review-evaluation-type1', {
    staticClass: "mod_listbox",
    attrs: {
      "rank": _vm.review.rank_good_pc_performance,
      "title": false
    },
    on: {
      "update:rank": function($event) {
        return _vm.$set(_vm.review, "rank_good_pc_performance", $event)
      }
    }
  }, [_c('template', {
    slot: "rank1"
  }, [_vm._v("スペックが低い")]), _vm._v(" "), _c('template', {
    slot: "rank2"
  }, [_vm._v("スペックが少し低い")]), _vm._v(" "), _c('template', {
    slot: "rank3"
  }, [_vm._v("普通")]), _vm._v(" "), _c('template', {
    slot: "rank4"
  }, [_vm._v("少しハイスペック")]), _vm._v(" "), _c('template', {
    slot: "rank5"
  }, [_vm._v("ハイスペック")])], 2)], 1)], 2), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": '業務の忙しさ',
      "require": true
    }
  }, [_c('template', {
    slot: "text"
  }, [_c('review-evaluation-type2', {
    staticClass: "mod_listbox",
    attrs: {
      "rank": _vm.review.rank_busy,
      "title": false
    },
    on: {
      "update:rank": function($event) {
        return _vm.$set(_vm.review, "rank_busy", $event)
      }
    }
  }, [_vm._v("\n          業務の忙しさ\n          "), _c('template', {
    slot: "low"
  }, [_vm._v("暇")]), _vm._v(" "), _c('template', {
    slot: "high"
  }, [_vm._v("忙しい")])], 2)], 1)], 2), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": '社風',
      "require": true
    }
  }, [_c('template', {
    slot: "text"
  }, [_c('review-evaluation-type2', {
    staticClass: "mod_listbox",
    attrs: {
      "rank": _vm.review.rank_good_corporate_culture,
      "title": false
    },
    on: {
      "update:rank": function($event) {
        return _vm.$set(_vm.review, "rank_good_corporate_culture", $event)
      }
    }
  }, [_c('template', {
    slot: "low"
  }, [_vm._v("堅実")]), _vm._v(" "), _c('template', {
    slot: "high"
  }, [_vm._v("挑戦的")])], 2)], 1)], 2), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": 'ソフト・言語・ツール等',
      "require": true
    }
  }, [_c('template', {
    slot: "text"
  }, [_c('review-evaluation-type2', {
    staticClass: "mod_listbox",
    attrs: {
      "rank": _vm.review.rank_good_tool,
      "title": false
    },
    on: {
      "update:rank": function($event) {
        return _vm.$set(_vm.review, "rank_good_tool", $event)
      }
    }
  }, [_c('template', {
    slot: "low"
  }, [_vm._v("古い")]), _vm._v(" "), _c('template', {
    slot: "high"
  }, [_vm._v("新しい")])], 2)], 1)], 2), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": 'あてはまる条件にチェックを入れてください',
      "require": true
    }
  }, [_c('template', {
    slot: "text"
  }, [_vm._l((this.$store.state.tags.strong_point_id), function(tag) {
    return [_c('label', {
      staticClass: "radioMargin"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.review.strong_point_id),
        expression: "review.strong_point_id"
      }],
      attrs: {
        "type": "checkbox",
        "name": "strong_point_id"
      },
      domProps: {
        "value": tag.tag_value,
        "checked": Array.isArray(_vm.review.strong_point_id) ? _vm._i(_vm.review.strong_point_id, tag.tag_value) > -1 : (_vm.review.strong_point_id)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.review.strong_point_id,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tag.tag_value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.review, "strong_point_id", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.review, "strong_point_id", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.review, "strong_point_id", $$c)
          }
        }
      }
    }), _vm._v("\n            " + _vm._s(tag.tag_name) + "\n          ")])]
  })], 2)], 2), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": '口コミ情報',
      "require": true
    }
  }, [_c('template', {
    slot: "text"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.review.company_review),
      expression: "review.company_review"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "12"
    },
    domProps: {
      "value": (_vm.review.company_review)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.review, "company_review", $event.target.value)
      }
    }
  })])], 2), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": 'エージェントの利用有無',
      "require": true
    }
  }, [_c('template', {
    slot: "text"
  }, [_vm._l(({
    0: {
      tag_value: '0',
      tag_name: 'エージエントを利用していない'
    },
    1: {
      tag_value: '1',
      tag_name: 'エージエントを利用した'
    }
  }), function(tag) {
    return [_c('div', [_c('label', {
      staticClass: "radioMargin"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.review.is_use_agent),
        expression: "review.is_use_agent"
      }],
      attrs: {
        "type": "radio",
        "name": "is_use_agent"
      },
      domProps: {
        "value": tag.tag_value,
        "checked": _vm._q(_vm.review.is_use_agent, tag.tag_value)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.review, "is_use_agent", tag.tag_value)
        }
      }
    }), _vm._v("\n              " + _vm._s(tag.tag_name) + "\n            ")])])]
  })], 2)], 2), _vm._v(" "), _vm._l((_vm.reviewAgents), function(agent, key) {
    return _c('div', [_c('review-agent', {
      attrs: {
        "index": key,
        "disable_check": !!((key + 1) == _vm.reviewAgents.length),
        "review_agent": agent
      },
      on: {
        "update:review_agent": function($event) {
          agent = $event
        },
        "append": _vm.appendAgent,
        "delete": _vm.deleteAgent
      }
    })], 1)
  }), _vm._v(" "), _c('text-group', {
    attrs: {
      "label": '現在もしくは今後、案件を紹介してほしいですか？',
      "require": true
    }
  }, [_c('template', {
    slot: "text"
  }, [_vm._l((this.$store.state.tags.is_need_job), function(tag) {
    return [_c('label', {
      staticClass: "radioMargin"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.review.is_need_job),
        expression: "review.is_need_job"
      }],
      attrs: {
        "type": "radio",
        "name": "is_need_job"
      },
      domProps: {
        "value": tag.tag_value,
        "checked": _vm._q(_vm.review.is_need_job, tag.tag_value)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.review, "is_need_job", tag.tag_value)
        }
      }
    }), _vm._v("\n            " + _vm._s(tag.tag_name) + "\n          ")])]
  })], 2)], 2), _vm._v(" "), (_vm.validation) ? _c('div', {
    staticClass: "alert alert-danger alert-dismissable"
  }, [_vm._l((_vm.validation), function(message) {
    return [(message) ? _c('p', [_vm._v(_vm._s(message))]) : _vm._e()]
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.isLock) ? _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": _vm.updateReview
    }
  }, [_vm._v("保存")]) : _vm._e(), _vm._v(" "), (_vm.isLock) ? _c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("保存中")]) : _vm._e()] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-info  row"
  }, [_c('p', {
    staticClass: "panel-body text-center"
  }, [_vm._v("\n        一番近い部分にチェックを入れてください。\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-info  row"
  }, [_c('p', {
    staticClass: "panel-body text-center"
  }, [_vm._v("\n        以下は常駐型フリーランスの方のみ、お答えください(非公開)\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4cf184f7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/review/Form.vue
// module id = 454
// module chunks = 1